import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setSendRepliesToContactsOnlyEnabledState', function setSendRepliesToContactsOnlyEnabledState(choice) {
    var optionState = getStore().currentState;
    optionState.sendRepliesToContactsOnlyEnabled = choice;
});
//# sourceMappingURL=setSendRepliesToContactsOnlyEnabledState.js.map